<template>

  <div>

    <div class="grid-container">

      <div class="header adas-header adas-first">

        <div class="split">
          <div class="col-30">
            <img src="../assets/ui/ui-adas.svg"/>
          </div>
          <div class="col-70">
            <div class="adas-info">
                <h4 class="redText">Your Safety Rides On Us</h4>
                <p>Advanced safety systems can be found in many of today’s new vehicles. If your car or truck has a front-facing camera, radar, or a special icon on the steering wheel or dashboard, you probably have one or more of these systems. This technology may require additional maintenance procedures to function as designed. In some cases, it may be necessary to perform regular calibrations.</p>
                <iframe src="https://player.vimeo.com/video/747347017?h=1486221dc4&amp;background=1" allowfullscreen="" frameborder="0" width="auto" height="auto" style="width: 100%; height: 290px;" allow="autoplay"></iframe>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!--Split-->
    <div class="grey-background stopComponent">
      <div class="grid-x alignmentVisuals grid-container">
        <h4 class="redText">Getting an Alignment?</h4>
        <p>Some advanced safety systems may need a calibration with an alignment to keep them working as designed. In addition to others, these can include:</p>
        <div class="alignmentTrio">
          <div class="col-3">
            <img class="alignment-icons" src="../assets/ui/ui-adas-lane.svg"/>
            <h6>Lane Departure Warning and Lane-Keeping Assistance</h6>
            <p>Help keep your vehicle in your lane</p>
          </div>
          <div class="col-3">
            <img class="alignment-icons" src="../assets/ui/ui-adas-braking.svg"/>
            <h6>Automated Emergency Braking and Collision Warning</h6>
            <p>Are designed to avoid accidents from multiple angles.</p>
          </div>
          <div class="col-3">
            <img class="alignment-icons" src="../assets/ui/ui-adas-cruise.svg"/>
            <h6>Adaptive Cruise Control</h6>
            <p>Aids in maintaining a safe distance between you and the vehicle ahead.</p>
          </div>
        </div>


</div>
    </div>

    <div class="grid-container">

      <div class="header adas-header">

        <div class="split">
          <div class="col-40">
            <div class="adas-info">
              <h4 class="redText">When is Calibration Needed? </h4>
              <p>Some advanced safety systems may need an occasional calibration. Your vehicle manufacturer may recommend an advanced safety system calibration after any of the following:</p>
              <div class="cell small-12 medium-5 medium-offset-.5">
                <ul class="adasPromiseList">
                  <li class="adasPromiseItems" v-for="service in adasContent.calibrationCases" :key="service">
                    <img height="20" width="20" :src="adasContent.checkmark" alt="green checkmark">
                    <p>{{service}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-60">
            <iframe src="https://player.vimeo.com/video/747421632?h=1c6aae2b6f&amp;background=1" allowfullscreen="" frameborder="0" width="630" height="295" style="width: 100%;" allow="autoplay"></iframe>
          </div>
        </div>

      </div>
    </div>

    <div class="grid-container">

      <div class="header adas-header">


        <div class="split">
          <div class="col-50 crop-calibration">
            <img src="../assets/calibration-advanced.jpeg"/>
          </div>
          <div class="col-50">
            <div class="adas-info">
              <h4 class="redText">Les Schwab Calibrates Advanced Safety Systems</h4>
              <p>Recalibration procedures vary by vehicle. We have the expertise to help you understand your vehicle's specific needs and help keep you rolling safely.</p>
            </div>
            <div class="adas-info">
              <h4 class="redText">Our Best Alignment Value Promise</h4>
              <p>We are always working to earn your trust. A big part of that is out best-in-the-industry warranty at no extra charge.</p>
              <div class="cell small-12 medium-5 medium-offset-.5">
                <ul class="adasPromiseList">
                  <li class="adasPromiseItems" v-for="service in adasContent.bestAlignmentCases" :key="service">
                    <img height="20" width="20" :src="adasContent.checkmark" alt="green checkmark">
                    <p>{{service}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>

export default {
  name: 'PageCamber',
  props: ['adasContent'],
  data() {
    return {
      passengerSliderValue: 50,
      driverSliderValue: 50,
    };
  },
}
</script>

<style lang="scss">

.adas-header {
  margin-top: 20px;
  margin-bottom: 20px;
}

.adas-first {
  margin-top: 50px;
}

.grey-background {
  background-color: #F2F3F4;
}

.col-50 {
  width: 50%;
}

.crop-calibration {
  overflow: hidden;
  height: 280px;
}

.col-30 {
  width: 30%;
}

.col-40 {
  width: 40%;
}

.col-60 {
  width: 60%;
}

.col-70 {
  width: 70%;
}


.split, .alignmentTrio {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  gap: 40px;

  @media(min-width: 992px) {
    align-items: unset;
    flex-direction: row;
  }
}

.alignmentVisuals {
  text-align: left;
  justify-content: center;
  padding: 2rem;

  .alignmentTrio {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    @media(min-width: 992px) {
      align-items: unset;
      flex-direction: row;
    }
  }

  .alignment-icons {
    margin-bottom: 20px;
    height: 50px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .col-3 {
    width: 30%;
  }
}

.adasPromiseList {
  padding: 0;

  .adasPromiseItems {
    display: flex;
    align-items: center;
    justify-items: center;
    gap: 10px;
    margin-bottom: 10px;

    p {
      margin: 0;
    }
  }
}
</style>
